import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import * as types from './mutation-types';

export function fetchBookmarkGroups({ commit }, userId) {
  return http.get(`${MINERVA_API_URL}/users/${userId}/bookmark_groups`, { params: { insertable: true } })
    .then(res => commit(types.SET_BOOKMARK_GROUPS, res.data))
    .catch(err => Promise.reject(err));
}

export function createBookmarkPage({ commit }, data) {
  return http.post(`${MINERVA_API_URL}/bookmark_groups/${data.bookmark_group_id}/bookmark_pages`, data)
    .then(res => commit(types.SET_BOOKMARK_PAGE, res.data))
    .catch(err => Promise.reject(err));
}

export function createBookmarkGroup({ commit }, data) {
  return http.post(`${MINERVA_API_URL}/bookmark_groups`, data)
    .then(res => commit(types.SET_BOOKMARK_GROUP, res.data))
    .catch(err => Promise.reject(err));
}
